$(document).ready(function(){
    function handleMenuHoverAndClick(sectionId) {
        var $section = $(sectionId);
        $section.find('.childlink-title').on('mouseenter click', function() {
            var target = $(this).data('target');
            $section.find('.childlink-title').removeClass('activeListItem');
            $(this).addClass('activeListItem');
            $section.find('.main-megamenu-item-inner').removeClass('activeItem');
            $(target).addClass('activeItem');
        });
    }
    for (var i = 1; i <= 5; i++) {
        var sectionId = '#MegaMenu-Content-' + i;
        handleMenuHoverAndClick(sectionId);
    }
    $('.menu-drawer__menu li details summary').click(function(){
    var details = $(this).parent('details');
    $('.menu-drawer__menu li details').not(details).removeAttr('open');
      //      $(".menu-drawer__inner-submenu .menu-drawer__menu li:first").addClass('activeHover');
      // $(".menu-drawer__submenu .main-megamenu-item-outer .main-megamenu-item-inner:first").addClass('activeItem');
  });
});
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  });